// @flow

import type {Language, RiskRating} from '@/types'

import React from 'react'

import './risk-filter.css'

type Prop = {
  l: Language,
  riskSummary: any,
  shownRiskRating: RiskRating,
  riskTypeChange: (RiskRating) => void,
}

const ifSelected = (shownRiskRating: RiskRating, count: number) =>
  (riskRating: RiskRating, riskClass: string) =>
    riskRating === shownRiskRating ? `${riskClass} active ${count > 0 ? '' : 'disable-label'}` : (count > 0 ? '' : 'disable-label')

const renderListRow = (
  ratingCount: number,
  shownRiskRating: RiskRating,
  riskTypeChange: (RiskRating) => void,
  riskRating: RiskRating,
  text: string,
  riskClass: string,
) => {
  const activeClass = ifSelected(shownRiskRating, ratingCount)
  return (
    <li role="presentation" className={activeClass(riskRating, riskClass)}>
      <a id={`badge_${riskRating}`} onClick={() => ratingCount > 0 ? riskTypeChange({riskLevel: riskRating}) : null}>
        <span className="rating">{riskRating}</span>
        <span className="separator"></span>
        <span className="rating-text">{text}</span>
        <span className="badge">{ratingCount}</span>
      </a>
    </li>
  )
}

export const RawRiskFilters = ({shownRiskRating, riskTypeChange, l, riskSummary}: Prop) => {
  return (
    <ul className="nav nav-pills risk pull-right" role="tablist">
      {renderListRow(riskSummary['bandACount'] ? riskSummary['bandACount'] : 0, shownRiskRating, riskTypeChange, 'A', l('Very low risk'), 'very-low')}
      {renderListRow(riskSummary['bandBCount'] ? riskSummary['bandBCount'] : 0, shownRiskRating, riskTypeChange, 'B', l('Low risk'), 'low')}
      {renderListRow(riskSummary['bandCCount'] ? riskSummary['bandCCount'] : 0, shownRiskRating, riskTypeChange, 'C', l('Moderate risk'), 'moderate')}
      {renderListRow(riskSummary['bandDCount'] ? riskSummary['bandDCount'] : 0, shownRiskRating, riskTypeChange, 'D', l('High risk'), 'high')}
      {renderListRow(riskSummary['bandECount'] ? riskSummary['bandECount'] : 0, shownRiskRating, riskTypeChange, 'E', l('Not rated'), 'not-rated')}
    </ul>
  )
}

export default RawRiskFilters



// WEBPACK FOOTER //
// ./src/views/analysis-page/companies/risk-filter.js